import VesselProperty from "./VesselProperty";

// This maps data key-values from Alerts to `VesselProperty`s
const VesselAlertDataPropertyMap = {
	[VesselProperty.NAME]: "Name",
	[VesselProperty.IMO]: "imo",
	[VesselProperty.MMSI]: "mmsi",
	[VesselProperty.TIMESTAMP]: "time_stamp",
	[VesselProperty.CLASSIFICATION]: "Classification",
	[VesselProperty.FLAG]: "Flag",
	[VesselProperty.DRAUGHT]: "Draught",
	[VesselProperty.SPEED]: "Speed",
	[VesselProperty.VOYAGE_DESTINATION]: "voyage_dest",
	[VesselProperty.VOYAGE_ETA]: "voyage_eta",
	[VesselProperty.COURSE]: "Course",
	[VesselProperty.HEADING]: "Heading",
	[VesselProperty.UPDATE]: "update",
	[VesselProperty.CALL_SIGN]: "call_sign",
	[VesselProperty.WIDTH]: "width",
	[VesselProperty.LENGTH]: "length",
	[VesselProperty.STATIC_UPDATE_AT]: "static_update_at",
	[VesselProperty.SPIRE_ID]: "spire_id",
	[VesselProperty.EXTRA]: "extra"
};
export default VesselAlertDataPropertyMap;
